import { createStore, combineReducers, compose } from 'redux'
import modalContactReducer from './reducers/modal-contact'

// Enable Redux devtools in non-production environments
const composeEnhancers = (
  process.env.NODE_ENV !== 'production' &&
  typeof window !== 'undefined' &&
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
) || compose

// Create and export the store
const createCustomStore = () => createStore(
  combineReducers({
    modalContact: modalContactReducer
  }),
  composeEnhancers
)

export default createCustomStore